import route from '@router/route';
import { backend } from '.';

const webOriginId = 1;

export function storeCaptcha(context) {
    return backend.post(route('recaptcha.store'), {
        context,
        origin: webOriginId,
        shown_at: new Date(),
    });
}

export function updateVerifiedCaptcha({ captchaId, isResolved = true }) {
    return backend.put(route('recaptcha.update', { id: captchaId }), {
        resolved: isResolved,
    });
}
